export default __webpack_public_path__ + "static/media/telegram.615937ef.svg";